import styled from "styled-components";

export const StyledGroupButton = styled.div`
  display: inline-flex;
  /* border: 1px solid ${({ theme }) => theme.colors.darkGray}; */
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  gap: 10px;
  width: 80%;
`;

export const StyledGroupButtonItem = styled.button.withConfig({
  shouldForwardProp: (prop) => !["isPrimary"].includes(prop),
})<{ isPrimary?: boolean }>`
  padding: ${({ theme }) =>
    `${theme.spacing(1.25)} ${theme.spacing(4)}`}; // maior
  height: 48px; // altura aumentada
  font-size: ${({ theme }) => theme.fontSizes.lg}; // fonte maior
  background-color: ${({ theme, isPrimary }) =>
    isPrimary ? theme.colors.vividBlue : theme.colors.white};
  color: ${({ theme, isPrimary }) =>
    isPrimary ? theme.colors.white : theme.colors.darkGray};
  border: 1px solid ${({ theme }) => theme.colors.darkGray};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  transition: background-color 0.2s ease;
  width: 100%;
`;
